import * as React from "react";
import Playground from "./Playground";

export default function Home() {
  return <Playground />;
}
